var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.titleColumn
    ? _c(
        "div",
        [
          !_vm.parentId && _vm.column.relation.requiresParentSave
            ? [
                _c(
                  "q-alert",
                  { attrs: { color: "primary", type: "warning" } },
                  [_vm._v("Must save before these can be created.")]
                )
              ]
            : [
                !_vm.isFilter
                  ? _c("div", [
                      _c(
                        "div",
                        { staticClass: "q-mb-md" },
                        [
                          _vm.addButton
                            ? _c("q-btn", {
                                staticClass: "no-shadow",
                                attrs: {
                                  icon: "add",
                                  size: "sm",
                                  flat: "",
                                  color: "secondary",
                                  label: _vm._f("singular")(
                                    "New " + _vm.column.label
                                  )
                                },
                                on: {
                                  click: function($event) {
                                    _vm.newFormModalOpen = !_vm.newFormModalOpen
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm.value
                            ? _c("q-btn", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.editModeActive,
                                    expression: "editModeActive"
                                  }
                                ],
                                staticClass: "on-right no-shadow",
                                attrs: {
                                  icon: "check",
                                  size: "sm",
                                  flat: "",
                                  color: "positive",
                                  label: _vm._f("relationLabel")(
                                    _vm.value,
                                    _vm.titleColumn,
                                    _vm.relationParentColumnMap[
                                      _vm.titleColumn.field
                                    ]
                                  )
                                },
                                on: {
                                  click: function($event) {
                                    _vm.editing = false
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm.editModeActive
                        ? _c(
                            "div",
                            [
                              _c(
                                "div",
                                { staticClass: "flex" },
                                [
                                  _c("q-btn", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.showBrowse,
                                        expression: "showBrowse"
                                      }
                                    ],
                                    staticClass: "no-shadow inline-flex",
                                    attrs: {
                                      color: _vm.inputBgColor,
                                      "text-color": "primary",
                                      rounded: "",
                                      icon: _vm.showOptions
                                        ? "keyboard arrow up"
                                        : "keyboard arrow down",
                                      loading: _vm.loading
                                    },
                                    on: { click: _vm.handleBrowseData }
                                  }),
                                  _vm.loaded
                                    ? _c(
                                        "q-search",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.showSearch,
                                              expression: "showSearch"
                                            }
                                          ],
                                          staticClass:
                                            "no-shadow inline-flex on-right",
                                          staticStyle: { "flex-grow": "1" },
                                          attrs: {
                                            placeholder: "",
                                            "hide-underline": "",
                                            color: _vm.inputBgColor,
                                            "inverted-light": "",
                                            clearable: ""
                                          },
                                          model: {
                                            value: _vm.term,
                                            callback: function($$v) {
                                              _vm.term = $$v
                                            },
                                            expression: "term"
                                          }
                                        },
                                        [
                                          _c("q-autocomplete", {
                                            attrs: {
                                              minCharacters: 1,
                                              "max-results": 25,
                                              "max-height": "400px"
                                            },
                                            on: {
                                              selected: _vm.selected,
                                              search: _vm.search
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c("q-slide-transition", [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.options &&
                                          _vm.options.length &&
                                          _vm.showOptions,
                                        expression:
                                          "options && options.length && showOptions"
                                      }
                                    ]
                                  },
                                  [
                                    _c("details-table", {
                                      attrs: {
                                        columns: _vm.relationColumns,
                                        "parent-column-map":
                                          _vm.relationParentColumnMap,
                                        selected: _vm.value,
                                        rows: _vm.options,
                                        "show-delete": false,
                                        "show-edit": _vm.allowEdit
                                      },
                                      on: {
                                        select: _vm.handleSelectClick,
                                        remove: _vm.handleRemove,
                                        edit: _vm.handleEditRequest
                                      }
                                    }),
                                    _c("div", { staticClass: "row q-mt-md" }, [
                                      _c(
                                        "div",
                                        { staticClass: "col-12" },
                                        [
                                          _c("q-pagination", {
                                            staticClass:
                                              "text-center justify-center",
                                            attrs: {
                                              value: _vm.pagination.page,
                                              color: "secondary",
                                              min: 1,
                                              max: _vm.maxPage,
                                              "max-pages": 15,
                                              "boundary-numbers": "",
                                              "boundary-links": ""
                                            },
                                            on: { change: _vm.handlePageChange }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ]),
                              _c(
                                "q-slide-transition",
                                [
                                  _c(
                                    "q-alert",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.showOptions &&
                                            !_vm.options.length &&
                                            !_vm.loading,
                                          expression:
                                            "showOptions && !options.length && !loading"
                                        }
                                      ],
                                      attrs: { type: "info" }
                                    },
                                    [
                                      _vm._v(
                                        "No " +
                                          _vm._s(
                                            _vm._f("plural")(_vm.column.label)
                                          ) +
                                          " found"
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.editModeActive
                        ? _c(
                            "div",
                            { staticClass: "flat-box" },
                            [
                              _c(
                                "q-card",
                                { attrs: { flat: "" } },
                                [
                                  _c(
                                    "q-card-main",
                                    [
                                      _c(
                                        "q-collapsible",
                                        { attrs: { opened: "" } },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "full-width",
                                              attrs: { slot: "header" },
                                              slot: "header"
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "q-title text-primary"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("relationLabel")(
                                                        _vm.value,
                                                        _vm.titleColumn,
                                                        _vm
                                                          .relationParentColumnMap[
                                                          _vm.titleColumn.field
                                                        ]
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm.subtitleColumn
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "q-caption text-grey-6"
                                                    },
                                                    [
                                                      _c("br"),
                                                      _vm._v(
                                                        "\n                  " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "relationLabel"
                                                            )(
                                                              _vm.value,
                                                              _vm.subtitleColumn,
                                                              _vm
                                                                .relationParentColumnMap[
                                                                _vm
                                                                  .subtitleColumn
                                                                  .field
                                                              ]
                                                            )
                                                          ) +
                                                          "\n                "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          ),
                                          _c("details-table", {
                                            attrs: {
                                              columns: _vm.relationColumns,
                                              rows: [_vm.value],
                                              selected: [_vm.value],
                                              "parent-column-map":
                                                _vm.relationParentColumnMap,
                                              "show-edit": _vm.allowEdit
                                            },
                                            on: {
                                              remove: _vm.handleRemove,
                                              edit: _vm.handleEditRequest
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "q-card-actions",
                                    { attrs: { align: "between" } },
                                    [
                                      _vm.showBrowse
                                        ? _c(
                                            "q-btn",
                                            {
                                              staticClass: "no-shadow",
                                              attrs: {
                                                color: "secondary",
                                                flat: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.editing = true
                                                }
                                              }
                                            },
                                            [
                                              _c("q-icon", {
                                                staticClass: "on-left",
                                                attrs: { name: "autorenew" }
                                              }),
                                              _vm._v(
                                                "\n              select different " +
                                                  _vm._s(
                                                    _vm._f("singular")(
                                                      _vm.column.label
                                                    )
                                                  ) +
                                                  "\n            "
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.realModel.id && _vm.allowEdit
                                        ? _c(
                                            "q-btn",
                                            {
                                              staticClass: "no-shadow",
                                              attrs: {
                                                color: "positive",
                                                flat: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.handleEditButton(
                                                    _vm.realModel.id
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("span", [
                                                _vm._v("edit/view record")
                                              ]),
                                              _c("q-icon", {
                                                staticClass: "on-right",
                                                attrs: { name: "open in new" }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.addButton && _vm.template === "form"
                        ? _c("div", [
                            _vm.newFormModalOpen
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "q-modal",
                                      {
                                        attrs: {
                                          "content-classes": "q-pa-lg",
                                          "content-css":
                                            "min-width: 70vw; max-width: 95vw",
                                          "no-backdrop-dismiss": "",
                                          "no-esc-dismiss": ""
                                        },
                                        model: {
                                          value: _vm.newFormModalOpen,
                                          callback: function($$v) {
                                            _vm.newFormModalOpen = $$v
                                          },
                                          expression: "newFormModalOpen"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "fit" },
                                          [
                                            _c("q-btn", {
                                              staticStyle: {
                                                top: "0",
                                                right: "0",
                                                position: "relative",
                                                float: "right"
                                              },
                                              attrs: {
                                                flat: "",
                                                icon: "close"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.newFormModalOpen = false
                                                }
                                              }
                                            }),
                                            _vm.newFormModalOpen
                                              ? _c(
                                                  "div",
                                                  [
                                                    _c(
                                                      "h3",
                                                      {
                                                        staticClass:
                                                          "q-display-1 text-secondary capitalize no-margin"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Add New " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "singular"
                                                              )(
                                                                _vm.column.label
                                                              )
                                                            )
                                                        )
                                                      ]
                                                    ),
                                                    _vm.relationResource
                                                      ? _c(
                                                          "base-form",
                                                          {
                                                            attrs: {
                                                              resource:
                                                                _vm.relationResource,
                                                              "parent-id": parseInt(
                                                                _vm.parentId
                                                              ),
                                                              "parent-resource":
                                                                _vm.parentResource,
                                                              "parent-resource-column":
                                                                _vm.column,
                                                              "skip-resource":
                                                                _vm.resource,
                                                              "is-modal": true
                                                            },
                                                            on: {
                                                              add: _vm.handleNew
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "full-width q-mt-md q-pb-lg",
                                                                attrs: {
                                                                  slot: "goback"
                                                                },
                                                                slot: "goback"
                                                              },
                                                              [
                                                                _c("q-btn", {
                                                                  attrs: {
                                                                    icon:
                                                                      "close",
                                                                    label:
                                                                      "Cancel / Close",
                                                                    color:
                                                                      "grey-6",
                                                                    flat: ""
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.newFormModalOpen = false
                                                                    }
                                                                  }
                                                                })
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm.template === "form"
                        ? _c("div", [
                            _vm.editFormModalOpen
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "q-modal",
                                      {
                                        attrs: {
                                          "content-classes": "q-pa-lg",
                                          "content-css":
                                            "min-width: 70vw; max-width: 95vw",
                                          "no-backdrop-dismiss": "",
                                          "no-esc-dismiss": ""
                                        },
                                        model: {
                                          value: _vm.editFormModalOpen,
                                          callback: function($$v) {
                                            _vm.editFormModalOpen = $$v
                                          },
                                          expression: "editFormModalOpen"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "fit" },
                                          [
                                            _c("q-btn", {
                                              staticStyle: {
                                                top: "0",
                                                right: "0",
                                                position: "relative",
                                                float: "right"
                                              },
                                              attrs: {
                                                flat: "",
                                                icon: "close"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.editFormModalOpen = false
                                                }
                                              }
                                            }),
                                            _vm.editFormModalOpen
                                              ? _c(
                                                  "div",
                                                  [
                                                    _vm.relationResource
                                                      ? _c(
                                                          "base-form",
                                                          {
                                                            attrs: {
                                                              resource:
                                                                _vm.relationResource,
                                                              "parent-resource":
                                                                _vm.parentResource,
                                                              "parent-resource-column":
                                                                _vm.column,
                                                              "skip-resource":
                                                                _vm.resource,
                                                              callback:
                                                                _vm.handleEdit,
                                                              "is-modal": true,
                                                              id: _vm.value.id,
                                                              compare:
                                                                _vm.compare,
                                                              compareId:
                                                                _vm.compareId
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "full-width q-mt-md q-pb-lg",
                                                                attrs: {
                                                                  slot: "goback"
                                                                },
                                                                slot: "goback"
                                                              },
                                                              [
                                                                _c("q-btn", {
                                                                  attrs: {
                                                                    icon:
                                                                      "close",
                                                                    label:
                                                                      "Cancel / Close",
                                                                    color:
                                                                      "grey-6",
                                                                    flat: ""
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.editFormModalOpen = false
                                                                    }
                                                                  }
                                                                })
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        : _vm._e()
                    ])
                  : _vm._e()
              ]
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }